var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gz-main-container"},[_c('GZ-Header'),_c('GZ-Content',[_c('router-view',{attrs:{"slot":"body"},slot:"body"})],1),_c('GZ-Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }